"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const GiftGraphicIcon = props => {
  const {
      size = 48
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "GIFT-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.982.56.117.108.109.11c.938.993.767 2.164-.78 3.656a14.584 14.584 0 0 1-5.15 2.491.495.495 0 0 1-.268-.004.49.49 0 0 1-.267.004 14.603 14.603 0 0 1-5.196-2.53C5.044 2.94 4.874 1.77 5.813.777l.11-.11.112-.103c1.023-.895 2.203-.737 3.735.75a13.804 13.804 0 0 1 2.242 3.941 13.804 13.804 0 0 1 2.279-3.985c1.492-1.442 2.669-1.6 3.69-.71m-2.955 1.384a12.838 12.838 0 0 0-1.962 3.348l-.152.403.42-.147a13.439 13.439 0 0 0 3.445-1.872c1.182-1.143 1.24-1.7.628-2.287-.63-.605-1.232-.549-2.379.555M6.615 1.39c-.612.588-.554 1.144.582 2.248A13.54 13.54 0 0 0 10.64 5.53l.467.165-.152-.403A12.722 12.722 0 0 0 9.034 1.99C7.847.84 7.244.784 6.615 1.389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.567 23.987a2.033 2.033 0 0 1-2.033-2.033V11.721h-.266c-.7 0-1.267-.566-1.267-1.266v-2.3c0-1.122.91-2.033 2.033-2.033h19.932c1.123 0 2.033.91 2.033 2.033v2.3c0 .7-.567 1.267-1.267 1.267h-.267v10.232c0 1.123-.91 2.033-2.032 2.033H3.567ZM9.2 11.721H2.534v10.233c0 .57.463 1.033 1.033 1.033H9.2V11.721m4.6 0h-3.6v11.266h3.6V11.721m7.666 0h-6.667v11.266h5.634c.57 0 1.033-.462 1.033-1.033V11.722M9.2 7.122l-7.166.001c-.57 0-1.033.463-1.033 1.033v2.3c0 .147.12.267.267.267H9.2v-3.6m4.6.001h-3.6v3.6h3.6v-3.6m8.166 0h-7.167v3.6h7.933c.148 0 .267-.12.267-.267v-2.3c0-.57-.463-1.033-1.033-1.033"
  }))));
};
GiftGraphicIcon.displayName = "GiftGraphicIcon";
GiftGraphicIcon.iconName = "Gift";
export default GiftGraphicIcon;